import { InjectionToken, Type } from '@angular/core';

export interface LazyComponents {
    [key: string]: { loadComponent: () => Promise<Type<any>> };
}

export const lazyMapC: LazyComponents = {
    JackpotTileContainerComponent: {
        loadComponent: () => import('./../jackpot-tiles/jackpot-tile-container.component').then((x) => x.JackpotTileContainerComponent),
    },
    JackpotsContainerComponent: {
        loadComponent: () => import('./../jackpot-tiles-v2/jackpots-container.component').then((x) => x.JackpotsContainerComponent),
    },
    DiscoverFeedComponent: {
        loadComponent: () => import('@casinocore/platform/discover-feed').then((m) => m.DiscoverFeedComponent),
    },
    CozyBingoWidgetComponent: {
        loadComponent: () => import('@casinocore/platform/cozy-bingo-widget').then((m) => m.CozyBingoWidgetComponent),
    },
    LiveGamesIframeComponent: {
        loadComponent: () => import('@casinocore/platform/live-games-section').then((m) => m.LiveGamesIframeComponent),
    },
    JackpotwidgetComponent: {
        loadComponent: () => import('@casinocore/platform/jackpot-widgets').then((m) => m.JackpotwidgetComponent),
    },
    JackpotWidgetRedesignComponent: {
        loadComponent: () => import('@casinocore/platform/jackpot-widgets').then((m) => m.JackpotWidgetRedesignComponent),
    },

    MustGoJackpotRedesignComponent: {
        loadComponent: () => import('@casinocore/platform/must-go-redesign').then((m) => m.MustGoJackpotRedesignComponent),
    },
    LiveCasinoComponent: {
        loadComponent: () => import('@casinocore/platform/livecasino').then((m) => m.LiveCasinoComponent),
    },
    CasinoGameVideosComponent: {
        loadComponent: () => import('@casinocore/platform/casino-game-videos').then((m) => m.CasinoGameVideosComponent),
    },
    NewsFeedComponent: {
        loadComponent: () => import('@casinocore/platform/news-feed-section').then((m) => m.NewsFeedComponent),
    },

    ParallaxAnimationComponent: {
        loadComponent: () => import('@casinocore/platform/parallax-animation').then((m) => m.ParallaxAnimationComponent),
    },
    PromoOfferWidgetComponent: {
        loadComponent: () => import('@casinocore/platform/promo-offer-widget').then((m) => m.PromoOfferWidgetComponent),
    },
    GamificationLoaderComponent: {
        loadComponent: () => import('@casinocore/platform/gamification').then((m) => m.GamificationLoaderComponent),
    },
    PromoEdsWidgetComponent: {
        loadComponent: () => import('@casinocore/platform/promo-eds-widget').then((m) => m.PromoEdsWidgetComponent),
    },
    NewGridGameMetaDataComponent: {
        loadComponent: () => import('@casinocore/platform/new-grid-game-metadata').then((m) => m.NewGridGameMetaDataComponent),
    },
    SlotRacesComponent: {
        loadComponent: () => import('@casinocore/platform/slot-races').then((m) => m.SlotRacesWrapperComponent),
    },
    SlotRacesPhase2Component: {
        loadComponent: () => import('@casinocore/platform/slot-races-phase2').then((m) => m.SlotRacesWrapperPhase2Component),
    },
    CasinoGameSelectorComponent: {
        loadComponent: () => import('@casinocore/platform/casino-game-selector').then((m) => m.CasinoGameSelectorComponent),
    },
    SuperButtonComponent: {
        loadComponent: () => import('@casinocore/platform/super-button').then((m) => m.SuperButtonComponent),
    },
    PromotionsBannerComponent: {
        loadComponent: () => import('@casinocore/platform/promotions-banner').then((m) => m.PromotionsBannerComponent),
    },
    InstagramWrapperComponent: {
        loadComponent: () => import('@casinocore/platform/instagram-section-wrapper').then((m) => m.InstagramWrapperComponent),
    },
    NewGameQuickInfoComponent: {
        loadComponent: () => import('@casinocore/platform/new-game-quick-info').then((m) => m.NewGameQuickInfoComponent),
    },
    BetMGMOriginalsComponent: {
        loadComponent: () => import('./../betmgm-originals/betmgm-originals.component').then((x) => x.BetMGMOriginalsComponent),
    },
    TopTenGamesComponent: {
        loadComponent: () => import('./../top-ten-games/top-ten-games.component').then((x) => x.TopTenGamesComponent),
    },
    BingoTournamentsComponent: {
        loadComponent: () => import('@casinocore/platform/bingo-tournaments').then((m) => m.BingoTournamentsComponent),
    },
    RPFavToggleSectionComponent: {
        loadComponent: () => import('./../rp-fav-toggle-section/rp-fav-toggle-section.component').then((m) => m.RPFavToggleSectionComponent),
    },
};

export const LAZY_COMPONENETS_MAPC = new InjectionToken('LAZY_COMPONENETS_MAPC', {
    factory: () => lazyMapC,
});
